export const TAG_MANAGER = process.env.NEXT_PUBLIC_GOOGLE_TAGMANAGER;
export const API_URL = process.env.API_URL;
